export const PALETA_COLOR_ENDPOINTS = {
  LISTAR: '/api/v1/recet/paleta-color',
} as const;

export const TECNOLOGIAS_ENDPOINTS = {
  LISTAR: '/api/v1/recet/tecnologias',
  STATS: '/api/v1/recet/tecnologias/stats',
  CATEGORIAS: '/api/v1/recet/tecnologias/categorias',
  OBTENER: (id: number) => `/api/v1/recet/tecnologias/${id}`,
  CREAR: '/api/v1/recet/tecnologias',
  IMPORTAR_DETECTAR: '/api/v1/recet/tecnologias/importar/detectar',
  IMPORTAR_CONFIRMAR: '/api/v1/recet/tecnologias/importar/confirmar',
  DESCARGAR_ORIGINAL: (ruta: string) =>
    `/api/v1/recet/tecnologias/importar/descarga?ruta=${encodeURIComponent(ruta)}`,
  ACTUALIZAR_CONTENIDO: (id: number) => `/api/v1/recet/tecnologias/${id}/contenido`,
  ACTUALIZAR_TITULO: (id: number) => `/api/v1/recet/tecnologias/${id}`,
  ELIMINAR: (id: number) => `/api/v1/recet/tecnologias/${id}`,
  OBSERVACIONES: (id: number) => `/api/v1/recet/tecnologias/${id}/observaciones`,
  EXPORTAR: (id: number, formato: string, modo: string) =>
    `/api/v1/recet/tecnologias/${id}/exportar?formato=${encodeURIComponent(formato)}&modo=${encodeURIComponent(modo)}`,
  EXPORTAR_VERSION: (id: number, formato: string, modo: string, version: number) =>
    `/api/v1/recet/tecnologias/${id}/exportar?formato=${encodeURIComponent(formato)}&modo=${encodeURIComponent(modo)}&version=${version}`,
  SOLICITAR_APROBACION: (id: number) => `/api/v1/recet/tecnologias/${id}/solicitar-aprobacion`,
  APROBAR: (id: number) => `/api/v1/recet/tecnologias/${id}/aprobar`,
  RECHAZAR: (id: number) => `/api/v1/recet/tecnologias/${id}/rechazar`,
  RETIRAR_SOLICITUD: (id: number) => `/api/v1/recet/tecnologias/${id}/retirar-solicitud`,
  SOLICITAR_REAPERTURA: (id: number) => `/api/v1/recet/tecnologias/${id}/solicitar-reapertura`,
  APROBAR_REAPERTURA: (id: number) => `/api/v1/recet/tecnologias/${id}/aprobar-reapertura`,
  RECHAZAR_REAPERTURA: (id: number) => `/api/v1/recet/tecnologias/${id}/rechazar-reapertura`,
} as const;

export const VERSIONES_ENDPOINTS = {
  LISTAR: (docId: number) => `/api/v1/recet/tecnologias/${docId}/versiones`,
  OBTENER: (docId: number, versionId: number) =>
    `/api/v1/recet/tecnologias/${docId}/versiones/${versionId}`,
  CREAR_SNAPSHOT: (docId: number) => `/api/v1/recet/tecnologias/${docId}/versiones`,
  ACTUALIZAR_ETIQUETA: (docId: number, versionId: number) =>
    `/api/v1/recet/tecnologias/${docId}/versiones/${versionId}`,
  RESTAURAR: (docId: number, versionId: number) =>
    `/api/v1/recet/tecnologias/${docId}/versiones/${versionId}/restaurar`,
  DIFF: (docId: number, from: number, to: number) =>
    `/api/v1/recet/tecnologias/${docId}/versiones/diff?from=${from}&to=${to}`,
} as const;

export const COMENTARIOS_ENDPOINTS = {
  LISTAR_HILOS: (docId: number) => `/api/v1/recet/tecnologias/${docId}/hilos`,
  CREAR_HILO: (docId: number) => `/api/v1/recet/tecnologias/${docId}/hilos`,
  AGREGAR_COMENTARIO: (docId: number, hiloId: number) =>
    `/api/v1/recet/tecnologias/${docId}/hilos/${hiloId}/comentarios`,
  RESOLVER_HILO: (docId: number, hiloId: number) =>
    `/api/v1/recet/tecnologias/${docId}/hilos/${hiloId}/resolver`,
  REABRIR_HILO: (docId: number, hiloId: number) =>
    `/api/v1/recet/tecnologias/${docId}/hilos/${hiloId}/reabrir`,
  ELIMINAR_HILO: (docId: number, hiloId: number) =>
    `/api/v1/recet/tecnologias/${docId}/hilos/${hiloId}`,
  EDITAR_COMENTARIO: (docId: number, hiloId: number, comentarioId: number) =>
    `/api/v1/recet/tecnologias/${docId}/hilos/${hiloId}/comentarios/${comentarioId}`,
  ELIMINAR_COMENTARIO: (docId: number, hiloId: number, comentarioId: number) =>
    `/api/v1/recet/tecnologias/${docId}/hilos/${hiloId}/comentarios/${comentarioId}`,
} as const;

export const SUGERENCIAS_ENDPOINTS = {
  LISTAR: (docId: number) => `/api/v1/recet/tecnologias/${docId}/sugerencias`,
  CREAR: (docId: number) => `/api/v1/recet/tecnologias/${docId}/sugerencias`,
  ACEPTAR: (docId: number, sugId: number) =>
    `/api/v1/recet/tecnologias/${docId}/sugerencias/${sugId}/aceptar`,
  RECHAZAR: (docId: number, sugId: number) =>
    `/api/v1/recet/tecnologias/${docId}/sugerencias/${sugId}/rechazar`,
  ACEPTAR_TODAS: (docId: number) => `/api/v1/recet/tecnologias/${docId}/sugerencias/aceptar-todas`,
  RECHAZAR_TODAS: (docId: number) =>
    `/api/v1/recet/tecnologias/${docId}/sugerencias/rechazar-todas`,
} as const;

export const TECNOLOGIA_SECCIONES_ENDPOINTS = {
  LISTAR: (docId: number) => `/api/v1/recet/tecnologias/${docId}/secciones`,
  OBTENER: (docId: number, secId: number) =>
    `/api/v1/recet/tecnologias/${docId}/secciones/${secId}`,
  ACTUALIZAR_CONTENIDO: (docId: number, secId: number) =>
    `/api/v1/recet/tecnologias/${docId}/secciones/${secId}/contenido`,
  AGREGAR: (docId: number) => `/api/v1/recet/tecnologias/${docId}/secciones`,
  ELIMINAR: (docId: number, secId: number) =>
    `/api/v1/recet/tecnologias/${docId}/secciones/${secId}`,
  REORDENAR: (docId: number) => `/api/v1/recet/tecnologias/${docId}/secciones/reordenar`,
} as const;

export const SECCIONES_ENDPOINTS = {
  LISTAR: '/api/v1/recet/secciones',
  DESCARGAR_PLANTILLA: '/api/v1/recet/secciones/plantilla',
  OBTENER: (id: number) => `/api/v1/recet/secciones/${id}`,
  CREAR: '/api/v1/recet/secciones',
  ACTUALIZAR: (id: number) => `/api/v1/recet/secciones/${id}`,
  DESHABILITAR: (id: number) => `/api/v1/recet/secciones/${id}`,
  HABILITAR: (id: number) => `/api/v1/recet/secciones/${id}/habilitar`,
  REORDENAR: '/api/v1/recet/secciones/reordenar',
} as const;

export const ESTUDIOS_CE_ENDPOINTS = {
  POR_TECNOLOGIA: (docId: number) => `/api/v1/recet/tecnologias/${docId}/estudios-ce`,
} as const;

export const REFERENCIAS_ENDPOINTS = {
  BUSCAR: '/api/v1/recet/referencias',
  OBTENER: (id: number) => `/api/v1/recet/referencias/${id}`,
  TOOLTIP: (id: number) => `/api/v1/recet/referencias/${id}/tooltip`,
  CREAR: '/api/v1/recet/referencias',
  ACTUALIZAR: (id: number) => `/api/v1/recet/referencias/${id}`,
  ELIMINAR: (id: number) => `/api/v1/recet/referencias/${id}`,
  POR_DOCUMENTO: (docId: number) => `/api/v1/recet/tecnologias/${docId}/referencias`,
  ASOCIAR: (docId: number, refId: number) =>
    `/api/v1/recet/tecnologias/${docId}/referencias/${refId}`,
  DESASOCIAR: (docId: number, refId: number) =>
    `/api/v1/recet/tecnologias/${docId}/referencias/${refId}`,
} as const;
